/** @format */

export const setFormDataDocuments = data => {
	const formData = new FormData();
	formData.append('_id', data._id);
	formData.append('typeDocument', JSON.stringify(data.typeDocument));
	formData.append('documents', data.documents);
	return formData;
};

export const setFormDataAvatar = data => {
	const formData = new FormData();
	formData.append('_id', data._id);
	formData.append('avatar', data.avatar);
	return formData;
};

export const formatPerson = data => {
	const persons = data.map(item => ({
		_id: item._id,
		age: item.age,
		appointment: item.appointment,
		avatar: item.avatar,
		birthdate: item.birthdate,
		comuna: item.comuna,
		conversation: item.conversation,
		documents: item.documents,
		editable: Boolean(item.editable),
		email: item.email,
		secondaryEmail: item.secondaryEmail,
		firstName: item.firstName,
		idCompany: item.idCompany,
		isPhoneVerified: item.isPhoneVerified,
		isUser: item.isUser,
		lastName: item.lastName,
		geolocation: item.geolocation,
		ownerId: item.ownerId,
		phone: item.phone,
		region: item.region,
		request: item.request,
		rut: item.rut,
		sharedUsers: item.sharedUsers,
		state: item.state,
		typeDocument: item.typeDocument,
		salary: item.salary,
		start: item.start,
		end: item.end,
		discount: item.discount,
		publications: item.publications,
		requestActivity: item.requestActivity,
		temporalOTs: item.temporalOTs,
	}));
	return persons;
};
